import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Logs de débogage pour vérifier les valeurs d'environnement

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('CONFIGURATION CRITIQUE: Les variables d\'environnement Supabase sont manquantes ou incorrectes!');
  console.error('Vérifiez le fichier .env et assurez-vous qu\'il contient VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY.');
}

// Configuration du client Supabase avec headers globaux pour éviter les erreurs 406
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  global: {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }
});

// Vérifier immédiatement la connexion Supabase
(async () => {
  try {
    const { data, error } = await supabase.from('prospects').select('count', { count: 'exact', head: true });
    if (error) {
      console.error('ERREUR DE CONNEXION SUPABASE:', error);
    } else {
    }
  } catch (err) {
    console.error('EXCEPTION lors de la vérification de la connexion Supabase:', err);
  }
})();